import type { SVGProps } from 'react';
export const SvgMention = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={16}
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="#101010"
			fillRule="evenodd"
			d="M12.243 3.757a6 6 0 1 0-.986 9.284 1 1 0 1 1 1.087 1.678A8 8 0 1 1 16 8a3 3 0 0 1-4.8 2.401A4 4 0 1 1 12 8a1 1 0 1 0 2 0c0-1.537-.586-3.07-1.757-4.243M10 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
			clipRule="evenodd"
		/>
	</svg>
);
